// import React from 'react';
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import PrivateRoute from './comps/PraviteRoute.jsx';
// import Core from './Corepage.jsx';
// import Task from './comps/task.jsx';
// import NotFoundPage from './comps/notFound.jsx';
// import { BrowserRouter, Route, Switch } from 'react-router-dom';
// import Landing from './comps/landing.jsx';
// import LoginForm from './comps/Login.jsx';
// import Otpverify from './comps/Otpverify.jsx';
// import Power from './comps/Power.jsx';

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   // <React.StrictMode>
//   <BrowserRouter>
//     <Switch>
//       <Route path="/" exact component={Landing} />
//       <Route path="/login" exact component={LoginForm} />
//       <Route path="/Otpverify" exact component={Otpverify} />
//       <PrivateRoute path="/power" component={Power} />
//       <PrivateRoute path="/task" component={Task} />
//       <PrivateRoute path="/coredataegap" component={Core} />
//       <Route path="*" component={NotFoundPage} />
//     </Switch>
//   </BrowserRouter>
//   // </React.StrictMode>
// );


import React from 'react';
import ReactDOM from "react-dom";
import "./index.css";
import PrivateRoute from './comps/PraviteRoute.jsx';
import Core from './Corepage.jsx';
import Task from './comps/task.jsx';
import NotFoundPage from './comps/notFound.jsx';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Landing from './comps/landing.jsx';
import LoginForm from './comps/Login.jsx';
import Otpverify from './comps/Otpverify.jsx';
import Dashboard from './comps/Dashboard.jsx';
import MyDataPage from './MyData1.jsx';
import Layout from './comps/Layout.jsx';
import PackageView from "./comps/Drawings.jsx";
import CreateFolder from './comps/createfolder.jsx';
import UploadData from './comps/UpdateFile.jsx';
import Drawingsdetailview from './comps/Drawingdetaileview.jsx';
 

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Switch>
      {/* Public routes */}
      <Route path="/" exact component={Landing} />
      <Route path="/login" exact component={LoginForm} />
      <Route path="/Otpverify" exact component={Otpverify} />

      {/* Core page - without sidebar layout */}
      <PrivateRoute path="/coredataegap" component={Core} />

      {/* Private routes with sidebar layout */}
      <Layout>
        <Switch>
          <PrivateRoute path="/dashboard" component={Dashboard} />
          <PrivateRoute exact path="/mydata1" component={MyDataPage} />
          <PrivateRoute path="/mydata/:packageName" component={PackageView} />
          <PrivateRoute path="/createfolder" component={CreateFolder} />
          <PrivateRoute path="/UpdateFile" component={UploadData} />
          <PrivateRoute path="/Drawingsbollon" component={PackageView} />
          <PrivateRoute path="/drawingdetailview/:packageName/:imageName" component={Drawingsdetailview} />
          <PrivateRoute path="/task" component={Task} />
          <Route component={NotFoundPage} />
        </Switch>
      </Layout>
    </Switch>
  </BrowserRouter>
);

